<template>
    <div class="ClfMomment">
      <div class="topTitle clfColor">
        <p class="clfBorderLeft">评论<span class="moment_num">共0条</span></p>
      </div>
      <div class="clf-moment-cont">
        <div class="putMsg">
          <div class="infoHead">
            <!-- <div class="imgUrl"></div> -->
            <img v-if="userInfo" :src="IMAGEPATH+userInfo.headPortrait" alt="" class="imgUrl" />
          </div>
          <div class="msgBox">
            <div class="msgBoxDiv">
              <el-input type="textarea" placeholder="写下你的想法" :rows="4" maxlength="1000" v-model="comment" resize="none" class="putInput">
              </el-input>
              <div class="el-rate starRate">
                <el-rate v-model="rate"></el-rate>
              </div>
            </div>
          </div>
          <div class="upComtBox">
            <div class="uploadImg_list" v-if="flieList.length > 0">
              <div class="imgList" v-for="(item, index) in flieList">
                <div class="dellImg" @click="handleDellImg(item)">
                  <img src="@/assets/imgs/close.png" alt="" />
                </div>
                <div class="imgBox">
                  <img :src="imgUrl + item" alt="" />
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between">
              <div class="leftUpload">
                <div class="upload-btn-fo" @click="handleUpload">
                  <img src="@/assets/imgs/upImg.png" alt=""/>
                  <span>选择照片</span>
                </div>
                <!-- multiple="multiple" -->
                <input
                  style="display: none"
                  ref="uploadInput"
                  type="file"
                  accept=".jpg,.png,.jpeg"
                  id="uploadInput"
                  @click="(e) => {e.target.value = ''}" @change="setImgs"/>
              </div>
              <div class="rightInfo">
                <p>文明上网理性发言，请遵守新闻评论服务协议</p>
                <div class="upBtn clfBgcColor" @click="addComment">发表评论</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  import * as qiniu from 'qiniu-js'
  import {getUploadToken} from '@/api/basics/uploadToken'
  import {addComment} from '@/api/basics/news'

  import Bus from "@/utils/bus";
  export default {
    data() {
      return{
        comment: "",
        rate: 4,
        uploadToken:'',
        flieList:[],
        imgUrl:'http://cdn.hns-whg.cn/',
        loginVisible:false,
        userInfo:''
      }
    },
    props:{
      sourceId:{
        type:String
      },
      type:{
        type:Number,
        default:4
      },
    },
    created(){
      this.userInfo  = this.$storage.getStorage('userInfo')
      this.getUploadToken() // 获取上传token
    },
    methods:{
      handleUpload() {
        this.$refs.uploadInput.click();
      },
      // 添加评论
      addComment() {
        let user = this.$storage.getStorage('userInfo')
        if (user) {
          const params = {
            sourceId: this.sourceId,
            content: this.comment,
            type:1,
            image:this.flieList,
            score:this.rate,
            model:7
          };
          // console.log(params,'params');
          addComment(params).then(res=>{
            // console.log(res,'添加评论');
            if(res.data.sucFlag){
              this.$message({
                message: res.data.message,
                type: "info",
              });
              this.comment = ''
              this.flieList = []
            }
          })
          // this.$message({
          //   message: '暂无法添加评论',
          //   type: "info",
          // });
        } else {
          Bus.$emit('getLoginVisible', true)
        }
      },
      getUploadToken(){
        getUploadToken().then(res=>{
          this.uploadToken = res.data.message
        })
      },
      setImgs(event) {
        let file = event.target.files[0];
        let _this = this
        // 获取身份的token
        // let token = 'LihtD-bxkoPzTCdZxwF7DbJNm_xl6I5sF5S8XMgF:QT_X9OuC2_v5tAVptM5PtB85wOA=:eyJzY29wZSI6Imhuc3doZyIsImRlYWRsaW5lIjoxNjg4MDkwNjQ3fQ=='
        let token = _this.uploadToken
        // 上传时的配置
        var config = {
          useCdnDomain: true
        };
        //  设置文件的配置
        var putExtra = {
          fname: "",
          params: {},
          mimeType: ["image/png", "image/jpeg", "image/jpg"]
        };
        //   实例化七牛云的上传实例
        var observable = qiniu.upload(file, null, token, putExtra, config);
        //   设置实例的监听对象
        var observer = {
          //   接收上传进度信息
          next(res) {
            // 上传进度
          },
          // 接收上传错误信息
          error(err) {
          },
          // 接收上传完成后的信息
          complete(res) {
            _this.flieList.push(res.key)
          }
        };
        // 上传开始
        var subscription = observable.subscribe(observer);
      },
      // 取消图片
      handleDellImg(item){
        let index = this.flieList.indexOf(item); 
        // console.log(index,'pp');
        if (index !== -1) {
          this.flieList.splice(index, 1);
        }
      },
    }
  };
  </script>
  
  <style scoped lang="less">
  @import "/src/css/base.css";
  .ClfMomment {
    margin-top: 48px;
    clear: both;
    margin-bottom: 20px;
  }
  .clfColor {
    color: #bb0015;
  }
  .ClfMomment .topTitle {
    margin-bottom: 23px;
    line-height: 23px;
    font-size: 24px;
    font-weight: 400;
  }
  .ClfMomment .clfBorderLeft {
    font-size: 28px;
    color: #333;
    border-left: unset;
  }
  .ClfMomment .moment_num {
    font-size: 14px;
    color: #999;
    padding-left: 8px;
  }
  .ClfMomment .clf-moment-cont {
    background-color: #ffffff;
  }
  .ClfMomment .infoHead {
    width: 74px;
    display: inline-block;
  }
  .ClfMomment .infoHead .imgUrl {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #f2f2f2;
  }
  .ClfMomment .msgBox {
    display: inline-block;
    width: calc(100% - 83px);
    vertical-align: top;
  }
  .ClfMomment .putMsg .msgBox {
    margin-bottom: 26px;
    position: relative;
  }
  .ClfMomment .putMsg .msgBox .msgBoxDiv {
    width: 100%;
    height: 136px;
    border-radius: 10px;
    border: 1px solid #dfdfdf;
    background-color: #f9f9f9;
  }
  .ClfMomment .putMsg .msgBox .putInput {
    display: block;
    padding: 10px;
    padding-bottom: 0;
    width: calc(100% - 20px);
    height: 89px;
    border: none;
    resize: none;
    font-size: 14px;
    color: #000;
    line-height: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
  }
  .ClfMomment .putMsg .msgBox .putInput /deep/.el-textarea__inner {
    background-color: transparent;
    border: none;
  }
  .ClfMomment .putMsg .msgBox .starRate {
    left: 18px;
    bottom: 8px;
    height: 20px;
    line-height: 1;
    position: absolute;
  }
  .ClfMomment .putMsg .upComtBox {
    padding-left: 83px;
  }
  .ClfMomment .putMsg .upComtBox .uploadImg_list{
    display: flex;
    flex-wrap: wrap;
  }
  .ClfMomment .putMsg .upComtBox .imgList{
    width: 115px;
    height: 115px;
    position: relative;
    margin: 0 15px 16px;
  }
  .ClfMomment .putMsg .upComtBox .imgList .imgBox img{
    width: 115px;
    height: 115px;
  }
  .ClfMomment .putMsg .upComtBox .imgList .dellImg {
    width: 31px;
    height: 31px;
    position: absolute;
    right: -14px;
    top: -11px;
    cursor: pointer;
    display: none;
  }
  .ClfMomment .upComtBox .imgList:hover .dellImg{
    display: block;
  }
  .ClfMomment .putMsg .upComtBox .upload-btn-fo {
    display: flex;
    align-items: center;
    padding: 6px 11px;
    border-radius: 4px;
    border: 1px solid #cecece;
    cursor: pointer;
  }
  .ClfMomment .putMsg .upComtBox .upload-btn-fo img {
    height: 14px;
    width: auto;
    margin-right: 4px;
  }
  .ClfMomment .putMsg .upComtBox .upload-btn-fo span {
    font-size: 14px;
    color: #999;
  }
  .ClfMomment .putMsg .upComtBox .rightInfo {
    display: flex;
    align-items: center;
  }
  .ClfMomment .putMsg .upComtBox .rightInfo p {
    font-size: 14px;
    font-weight: 400;
    color: #999;
    display: inline-block;
  }
  .ClfMomment .upBtn {
    width: 143px;
    height: 44px;
    text-align: center;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin-left: 24px;
    line-height: 44px;
    display: inline-block;
    cursor: pointer;
  }
  .ClfMomment .upBtn {
    width: 143px;
    height: 44px;
    text-align: center;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin-left: 24px;
    line-height: 44px;
    display: inline-block;
    cursor: pointer;
  }
  .clfBgcColor {
    background: #bb0015 !important;
  }
  </style>